import { atom } from 'recoil';

export const setFetchPatientData = atom({
    key: 'setFetchPatientData', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  